import React from "react";
import "./Footer.css";
import { useRef, useEffect, useState } from "react";
const Footer = () => {
    const noteRef = useRef(null);
    const [animationStyle, setAnimationStyle] = useState({});
  
    useEffect(() => {
  
  if (noteRef.current) {
        const textWidth = noteRef.current.scrollWidth;
        const containerWidth = noteRef.current.parentElement.offsetWidth;
  
        // Duration based on distance, adjust speed here
        const duration = ((textWidth + containerWidth) / 100) * 1.1; // seconds, 1 = speed factor
  
        // Create a dynamic animation
        const styleSheet = document.styleSheets[0];
        const animationName = "slideDynamic";
  
        // Remove old animation if exists
        for (let i = styleSheet.cssRules.length - 1; i >= 0; i--) {
          if (styleSheet.cssRules[i].name === animationName) {
            styleSheet.deleteRule(i);
          }
        }
  
        styleSheet.insertRule(`
          @keyframes ${animationName} {
            0% { transform: translateX(${containerWidth}px); }
            100% { transform: translateX(-${textWidth}px); }
          }
        `, styleSheet.cssRules.length);
  
        setAnimationStyle({
          animation: `${animationName} ${duration}s linear infinite`
        });
      }
    }, []);

  return (
    <div className="footer">
      <div className="footer-ticker">
        <div 
          ref={noteRef} className="footer-note" style={animationStyle}>
          <h5>
            <span class="new-badge">NEW</span>
            - We are now live with the E-Invoice feature. IRN-based upload is mandatory for E-Invoice eligible GSTINs under <strong style={{color:"White"}}>ABCL-HO</strong> and <strong style={{color:"White"}}>ABFSSL</strong>. 
              Please upload invoices after 48-hours of processing period from IRN generation.
          </h5>
        </div>
      </div>
      <h5>
        Copyright &#169; 2024, Developed by ABFSSL || All Rights Reserved.
      </h5>
    </div>
  );
};

export default Footer;
